import {
  ShaderMount,
  meshGradientFragmentShader,
  getShaderColorFromString,
  ShaderFitOptions,
} from '@paper-design/shaders';

const SPEED = 0.56;

function initHeroGradient(container: HTMLElement) {
  const colors = ['#ffe0e0', '#f59eb8', '#ff70ae'].map(getShaderColorFromString);

  const mount = new ShaderMount(
    container,
    meshGradientFragmentShader,
    {
      u_colors: colors,
      u_colorsCount: colors.length,
      u_distortion: 0.45,
      u_swirl: 0.28,
      u_grainMixer: 1,
      u_grainOverlay: 0.2,
      u_scale: 0.96,
      u_fit: ShaderFitOptions['none'],
      u_rotation: 0,
      u_offsetX: 0.12,
      u_offsetY: 0,
      u_originX: 0.5,
      u_originY: 0.5,
      u_worldWidth: 0,
      u_worldHeight: 0,
    },
    undefined,    // webGlContextAttributes
    SPEED,        // speed
    0,            // frame
    1,            // minPixelRatio
    1920 * 1080,  // maxPixelCount
  );

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = true;

  const sync = () => mount.setSpeed(visible && !reduced.matches ? SPEED : 0);
  const onMotionChange = () => sync();

  reduced.addEventListener('change', onMotionChange);

  const io = new IntersectionObserver(
    ([entry]) => {
      visible = entry.isIntersecting;
      sync();
    },
    { threshold: 0 },
  );
  io.observe(container);

  sync();

  return () => {
    reduced.removeEventListener('change', onMotionChange);
    io.disconnect();
    mount.dispose();
  };
}

const el = document.getElementById('hero-bg');
if (el) initHeroGradient(el);